import { Router } from 'vue-router';
import { useAuthStore } from '@/modules/admin/stores/auth';
import { UserRoles } from '@/modules/admin/interfaces/UserRoles';
import { Urls } from '@/config/Urls';

export const setupRouterGuards = (router: Router) => {
  router.beforeEach((to, _from, next) => {
    try {
      const authStore = useAuthStore();
      const isAuthenticated = !!authStore.user?.role;
      const publicRoutes = [
        Urls.LOGIN,
        Urls.SIGNUP,
      ];

      const isPublicRoute = publicRoutes.some((route) => to.path.startsWith(route));
      const requiresAuth = isPublicRoute ? false : (to.meta.requiresAuth !== false);

      if (!isAuthenticated && requiresAuth) {
        next({
          path: Urls.LOGIN,
          query: { redirect_url: to.fullPath },
        });
      } else if (
        isAuthenticated &&
        (to.path === Urls.LOGIN || to.path === Urls.SIGNUP)
      ) {
        if (authStore.user?.role) {
          next(Urls.FEED);
        } else {
          next();
        }
      } else if (isAuthenticated && requiresAuth) {
        const requiresAdmin = to.meta.requiresAdmin === true;
        if (requiresAdmin) {
          const userRole = authStore.user?.role?.name;
          if (userRole !== UserRoles.ADMIN) {
            next('/forbidden');
            return;
          }
        }
        const requiresSupervisor = to.meta.requiresSupervisor === true;
        if (requiresSupervisor) {
          const userRole = authStore.user?.role?.name;
          if (
            userRole !== UserRoles.ADMIN &&
            userRole !== UserRoles.GATEKEEPER &&
            userRole !== UserRoles.SUPERVISOR
          ) {
            next('/forbidden');
            return;
          }
        }
        const requiredRoles = to.meta.roles as string[] | undefined;
        if (requiredRoles && requiredRoles.length > 0) {
          const userRole = authStore.user?.role?.name;
          if (!userRole || !requiredRoles.includes(userRole)) {
            next('/forbidden');
            return;
          }
        }
        next();
      } else {
        next();
      }
    } catch (error) {
      console.error('Router guard error:', error);
      next(Urls.LOGIN);
    }
  });
};

